import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/functions'

const config = {
  apiKey: 'AIzaSyDeWgb1dz3ZQG7O8pS66ztCctoc9U17XOw',
  authDomain: 'daria-lush.firebaseapp.com',
  databaseURL: 'https://daria-lush.firebaseio.com',
  projectId: 'daria-lush',
  storageBucket: 'daria-lush.appspot.com',
  messagingSenderId: '847425999318',
  appId: '1:847425999318:web:809b48c5147709f95f5477',
}

firebase.initializeApp(config)

export const app = firebase.app()
export const auth = firebase.auth()
export const functions = firebase.functions()
